<script>
  import { slide } from "svelte/transition";

  export let width;
  export let text;
  export let type;
  export let isMobile;

  const backgroundLookup = {
    "Mission-driven company": "255, 255, 255",
    "Policy & government": "219, 65, 87",
    "Nonprofits & institutions": "22, 177, 169",
    "Impact investment": "240, 182, 79",
  };

  const customProp = `--tooltip-color: ${backgroundLookup[type]}`;

  // https://github.com/sveltejs/svelte/issues/4712#issuecomment-720146231
  import { isSafari } from "../stores/global.js";
  function safariHandler(node) {
    if ($isSafari) {
      node.style.overflow = "hidden";
    }
  }
</script>

<div
  class="expanded-content {isMobile ? 'mobile' : 'desktop'}"
  style="width: {width};
  {customProp}"
  transition:slide={{ duration: 500 }}
  use:safariHandler
>
  <p>{@html text}</p>
</div>

<style>
  .expanded-content {
    color: white;
    font-weight: 400;
    padding: 10px 12px;
    border-radius: 6px 6px 0 0;
    font-family: var(--font-small);
    line-height: 1.2;
    pointer-events: none;
    z-index: 10;
    position: relative;
    font-size: 1rem;
    margin: 12px 0;
    user-select: none;
    border-bottom: 5px solid rgb(var(--tooltip-color));
    background: #2d2d2d;
    background: linear-gradient(
      to bottom right,
      rgb(25, 25, 25) 50%,
      rgb(var(--tooltip-color)) 300%
    );
    /* max-width: 400px; */
  }

  :global(.expanded-content a) {
    pointer-events: all;
    color: rgb(var(--tooltip-color));
    transition: text-decoration-color 300ms;
    text-decoration: underline;
    text-decoration-color: transparent;
    -webkit-text-decoration-color: transparent;
    -moz-text-decoration-color: transparent;
  }

  :global(.expanded-content a:hover) {
    text-decoration-color: rgb(var(--tooltip-color));
  }

  .mobile {
    transform: translateX(45%);
    max-width: 75vw;
  }

  @media screen and (max-width: 450px) {
    .expanded-content {
      font-size: 0.85rem;
    }
  }
</style>
